import React from "react";
import { RecordsTable } from "../../Admin/RecordsTable";
import Pagination from "../../Shared/pagination";
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';

export default class PageableTable extends React.Component {
  render() {
    const { pagingState, columns, ...props } = this.props
    return (
      <LoadingIndicator>
        <div className='row'><div className='col-md-6'>
          {this.props.setTextFilter &&
            <input type="text" placeholder="Search" className='form-control input-sm' defaultValue={pagingState.textFilter} onChange={e => this.props.setTextFilter(e.target.value)} />
          }</div>
          <div className='col-md-6'>
            <span className='float-right'>
              {pagingState.totalPages > 1 && <Pagination currentPage={pagingState.currentPage} totalPages={pagingState.totalPages} onChange={this.props.onPageChange} />}
            </span>
          </div>
        </div>

        <RecordsTable totalMatches={pagingState.totalMatches} data={pagingState.data} columns={columns} {...props} />


      </LoadingIndicator>);
  }
}
